import "core-js/modules/es.array.map.js";
import { computed, defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
/**
 * Component with card reader options
 *
 * @component
 * @example
 * <select-card-reader/>
 */

export default defineComponent({
  name: "SelectCardReader",
  setup: function setup() {
    var _useI18n = useI18n({
      useScope: "global"
    }),
        t = _useI18n.t;

    var statuses = computed(function () {
      return POSConfigModule.groupTerminals.map(function (item) {
        return {
          id: item,
          label: item
        };
      });
    });
    return {
      statuses: statuses,
      t: t
    };
  }
});